import { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import { parseQueryStringToObject } from '../../utils/stringUtils'
import { LocalStore } from '../../utils/LocalStore'
import userService from '../../services/user.service'
import { initWechat } from '../../utils/helper'
import { USER_STATUS } from '../../constants/config'
import orderService from '../../services/orders.service'
import DocumentTitle from 'react-document-title'
import loadingGif from '../../resources/images/loading.gif'
import errorPng from '../../resources/images/error.png'
import * as Constants from '../../constants/config'
import * as Sentry from '@sentry/browser'

const CallbackLogin = props => {
    const [isNotPermission, setisNotPermission] = useState(false)
    const [msg, setMsg] = useState('Đang xác thực, vui lòng đợi trong giây lát.')
    const { history } = props

    useEffect(() => {
        console.log('Authentication')
        // Hủy sự kiện cảnh báo khi load trang
        window.onbeforeunload = null

        let queryString = props.location.search || ''
        if (queryString.indexOf('?') > -1) {
            queryString = queryString.replace(/\?/g, '')
        }
        const params = parseQueryStringToObject(queryString)
        console.log('params', params)

        // clear old session
        LocalStore.getInstance().save('loginSession', null)
        LocalStore.getInstance().save('pinToken', '')
        LocalStore.getInstance().save('currentLoggedUser', null)
        LocalStore.getInstance().save('ordersStatistics', null)
        LocalStore.getInstance().save('articleList', [])
        LocalStore.getInstance().save('articleSeen', false)
        LocalStore.getInstance().save('articleShow', true)
        LocalStore.getInstance().save('rsocketConnected', { connected: false })
        console.log('params', params)
        if (params && params['access_token']) {
            //query với access_token để lấy user
            userService.getCurrentUser(
                {
                    headers: {
                        Authorization: `Bearer ${params.access_token}`,
                        referrerPolicy: 'no-referrer',
                    },
                },
                (error, res) => {
                    console.log('getCurrentUser', error, res)
                    if (res) {
                        console.log('run vao day')
                        const redirectUrl = LocalStore.getInstance().read('redirectUrl') || '/'
                        LocalStore.getInstance().save('currentLoggedUser', res)
                        LocalStore.getInstance().save('redirectUrl', null)
                        LocalStore.getInstance().save('loginSession', { id: params.access_token })
                        Sentry.configureScope(scope => {
                            scope.setUser({ email: res && res.email, username: res && res.username })
                        })
                        // config clarity
                        const currentProjectInfo = LocalStore.getInstance().read('currentProjectInfo') || {}
                        const idUser = res.id
                        const userName = res.username
                        const tenant = currentProjectInfo.code
                        window.clarity('set', 'custom-id', idUser)
                        window.clarity('set', 'friendly-name', userName)
                        window.clarity('set', 'tenant', tenant)
                        // initialWechat
                        initWechat(res)
                        //kiểm tra trạng thái của User
                        if (res.customerStatus === USER_STATUS.LOCKED || res.customerStatus === USER_STATUS.INACTIVE) {
                            history.push({
                                pathname: '/403',
                            })
                        } else {
                            // connect websocket
                            if (
                                navigator &&
                                navigator.serviceWorker &&
                                navigator.serviceWorker.controller &&
                                navigator.serviceWorker.controller.postMessage
                            ) {
                                let endpoint = process.env.REACT_APP_NOTIFICATION_WSS + '?access_token=' + params.access_token
                                const currentProjectInfo = LocalStore.getInstance().read('currentProjectInfo') || {}
                                const tenantConfig = currentProjectInfo.tenantConfig || {}
                                navigator.serviceWorker.controller.postMessage({
                                    title: Constants.WS_ON_CONNECT,
                                    endpoint: endpoint,
                                    appName: currentProjectInfo.name,
                                    icon: tenantConfig.customFavicon,
                                })
                            }
                            // lấy ra số lượng bản ghi order theo trạng thái
                            // query 1 lần duy nhất khi load trang
                            orderService.getOrdersStatistics(
                                {
                                    headers: {
                                        Authorization: `Bearer ${params.access_token}`,
                                        referrerPolicy: 'no-referrer',
                                    },
                                },
                                (e, r) => {
                                    if (r) {
                                        LocalStore.getInstance().save('ordersStatistics', r)
                                        setMsg(`Chào ${res.fullname}, bạn sẽ được chuyển về trang chủ trong giây lát.`)
                                        setTimeout(() => {
                                            if (redirectUrl === '/') {
                                                history.replace(redirectUrl)
                                            } else {
                                                let link = redirectUrl.split('#')
                                                history.replace(link[1])
                                            }
                                        }, 1500)
                                    } else {
                                        setTimeout(() => {
                                            setMsg('Đã xảy ra lỗi vui lòng đăng nhập lại')
                                            history.replace('/login')
                                        }, 1500)
                                    }
                                }
                            )
                            // lấy ra các thông báo
                            this.getArticle()
                            this.getCustomerExchangeRate()
                        }
                    } else {
                        setTimeout(() => {
                            setMsg('Đã xảy ra lỗi vui lòng đăng nhập lại')
                            setisNotPermission(true)
                            history.replace('/login')
                        }, 1500)
                        console.log('run vao loi')
                    }
                }
            )
        } else {
            history.replace('/login')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const logout = () => {
        userService.logout()
    }
    return (
        <DocumentTitle title={`Xác thực...`}>
            <div className={'splash-container'}>
                {!isNotPermission ? (
                    <div className="dpl-flex flex-direction-column">
                        <img
                            src={loadingGif}
                            alt=""
                            style={{ margin: 'auto' }}
                        />
                        <p className="splash-text txt-color-black2 mgt25">{msg}</p>
                    </div>
                ) : (
                    <div className={'text-center margin-auto utmhelve-regular'}>
                        <div className={'text-center margin-auto utmhelve-regular'}>
                            <img
                                src={errorPng}
                                alt=""
                            />
                        </div>
                        <div className="txt-center">
                            <p className="splash-text txt-color-black2 mgt20">Máy chủ phản hồi quá chậm.</p>
                            <p className="splash-text txt-color-black2 mgt20">
                                Bạn có thể thử lại hoặc liên hệ quản lý để được hỗ trợ.
                            </p>
                            <div className={'mgt50'}>
                                <button className="splash-text txt-color-blue2 ">
                                    <i className="fas fa-undo-alt mgr5" /> <span>Thử lại</span>
                                </button>
                                <button
                                    onClick={logout}
                                    className="splash-text cursor-pointer txt-color-blue2 mgl25"
                                >
                                    <i className="fas fa-sign-out-alt mgr5" /> <span>Đăng xuất</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </DocumentTitle>
    )
}
export default withNamespaces()(CallbackLogin)
